// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import stringify from "fast-stable-stringify";

export function b64Encode(a: string): string {
  const encoded = Buffer.from(a || "", "utf8").toString("base64");
  return encoded.replace("+", "-").replace("/", "_").replace(/=+$/, "");
}

export function b64Decode(encoded: string): string {
  encoded = encoded.replace("-", "+").replace("_", "/");
  while (encoded.length % 4) {
    encoded += "=";
  }
  return Buffer.from(encoded, "base64").toString("utf8");
}

export async function* toAsyncIterable<T>(...args: T[]): AsyncIterable<T> {
  for (const arg of args) {
    yield arg;
  }
}

export function fillArray<T>(size: number, value: () => T): T[] {
  const rv: T[] = new Array(size);
  for (let i = 0; i < size; ++i) {
    rv[i] = value();
  }
  return rv;
}

export function nestedGet<T>(
  obj: any,
  path: (string | number)[],
  defaultValue?: T,
): T {
  const object = obj;
  for (const pathElement of path) {
    if (!(pathElement in obj)) {
      if (typeof defaultValue === "undefined") {
        throw new Error(
          `Could not find path ${JSON.stringify(
            path,
          )} within object ${JSON.stringify(object)}`,
        );
      }
      return defaultValue;
    }
    obj = obj[pathElement];
  }
  return obj as T;
}

export const jsonHash = stringify;

export function slugify(a: any): string {
  return b64Encode(jsonHash(a));
}

export function deslugify(b: string): any {
  return JSON.parse(b64Decode(b));
}

export function notEmpty<TValue>(
  value: TValue | null | undefined,
): value is TValue {
  return value !== null && value !== undefined;
}
